import React, { useEffect, useState } from 'react'
import "./LiveCouponData.css";
import { DataGrid, GridColDef, GridFilterModel, GridOverlay } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbar';
import { PageState } from '../../types';
import { Loader } from '../../../../components/loader/Loader';
import { CustomLoader, columnsData, fetchData, filteredColumnsData} from './service/LiveCouponDataService';
import { PAGE_DETAILS, PAGE_SIZE } from './couponUtils';
import { Stack, TablePagination } from '@mui/material';
import { MetaData } from '../../utils/utils';
import { persistCouponFilters, updateConfigAndMetaData } from '../../services/services';


/**
 * this component is main grid for showing live coupons.
 * it also filters the data according to start date, end date, coupon id
 * @returns 
 */

function LiveCouponData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: PAGE_SIZE,
        page: 0,
    });

    const [filterParams, setFilterParams] = useState<GridFilterModel | undefined>(() => {
        const storedFilters = localStorage.getItem('filterParams');
        return storedFilters ? JSON.parse(storedFilters) : undefined;
    });

    const [pageState, setPageState] = useState<PageState>({
        data: [],
        // total: 0,
    })
    const [sortParams, setSortParams] = useState<string>(() => {
        return localStorage.getItem('sortParams') || ''; 
    });
    

    const [nextPageState, setnextPageState] = useState<PageState>({
        data: [],
    })
    const [disableNextButton, setDisableNextButton] = useState<boolean>(true);

    const [isContainsFilterApplied, setIsContainsFilterApplied] = useState<boolean>(false);



    const handleFilterModelChange = (params: GridFilterModel) => {
        setFilterParams(params);
        // Check if the filter is empty
        if (params.items.length === 0 || !params.items[0].value) {
            setIsContainsFilterApplied(false);
            return;
        }

        if(params.items[0].operator === 'contains'){
            setSortParams('');
            setIsContainsFilterApplied(true);
        } else {
            setIsContainsFilterApplied(false);
        }
        if(persistCouponFilters())
            localStorage.setItem('filterParams', JSON.stringify(params));
    };

    const handleChangePage = (event: unknown, newPage: number) => {
        setPaginationModel({ ...paginationModel, page: newPage });
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        const pageSize = parseInt(event.target.value, 10);
        setPaginationModel({ ...paginationModel, pageSize, page: 0 });
    };

    const mappedArray = pageState.data.map(item => {
        let newItem = { ...item };
        if (newItem.source === null) {
            newItem.source = "Portal";
        }
        if (newItem.isBannerPresent === true) {
            newItem.isBannerPresent = "1";
        }
        if (newItem.isBannerPresent === false) {
            newItem.isBannerPresent = "0";
        }
        return newItem;
    });

    useEffect(() => {
        (async () => {
            if (filterParams?.items[0]?.value) {
                await updateConfigAndMetaData();
                const timeout = setTimeout(() => {
                    setLoading(true);
                    fetchData(paginationModel.pageSize,paginationModel.page, filterParams, sortParams, setLoading, setPageState);
                }, 400);
                return () => {
                    return clearTimeout(timeout)
                };
            }
            else {
                await updateConfigAndMetaData();
                setLoading(true);
                fetchData(paginationModel.pageSize,paginationModel.page,filterParams, sortParams, setLoading, setPageState);
            }
          })();

    }, [paginationModel.page, paginationModel.pageSize, paginationModel.page,filterParams?.items[0]?.value, filterParams, sortParams]);

    useEffect(() => {
        (async () => {
            await updateConfigAndMetaData();
            fetchData(paginationModel.pageSize,paginationModel.page+1,filterParams, sortParams,setLoading, setnextPageState);
            if (nextPageState.data.length > 1) {
                setDisableNextButton(false);
            } else {
                setDisableNextButton(true);
            }
          })();
    }, [paginationModel.page, paginationModel.pageSize, nextPageState.data.length,filterParams?.items[0]?.value, filterParams, sortParams]);

    useEffect(() => {
        if(persistCouponFilters())
            localStorage.setItem('sortParams', sortParams);
    }, [sortParams]);
    
    useEffect(() => {
        if (persistCouponFilters() && filterParams) {
            localStorage.setItem('filterParams', JSON.stringify(filterParams));
        }
    }, [filterParams]);
    
    
    console.log(mappedArray)

    return (
        <div className="manageCouponDataGridContainer">
            <DataGrid className='live_dashboard_table' disableColumnMenu={true} disableRowSelectionOnClick
                slotProps={{
                    panel: {
                        sx: {
                            top: '-55px !important',
                            right: '25px !important', 
                            left: 'auto !important',
                        },
                    },
                }}
                sx={{ paddingInline: '20px' }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            CustomFilter: false,
                        },
                    },
                }}
                getRowId={(row: any) => row.schemeId}
                rows={mappedArray}
                rowCount={99999}
                loading={loading}
                slots={{
                    loadingOverlay: CustomLoader,
                    toolbar: ()=><CustomToolbar sortParams={sortParams} setSortParams={setSortParams} disabled={isContainsFilterApplied}/>,
                    pagination: (props) => (
                        <TablePagination
                            {...props}
                            rowsPerPageOptions={PAGE_DETAILS.page_window}
                            component="div"
                            count={99999}
                            page={paginationModel.page}
                            rowsPerPage={paginationModel.pageSize}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            nextIconButtonProps={{
                                disabled: disableNextButton,
                            }}
                        />
                    ),
                    noResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                          No row found
                        </Stack>
                    )
                }}
                columns={filteredColumnsData()}
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={PAGE_DETAILS.page_window}
                filterModel={filterParams}
                onFilterModelChange={handleFilterModelChange}
            />
        </div>
    );
}
export default LiveCouponData